import { styled } from '@vebox/etui-system';
import { Component, createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { H5 } from '../H5/H5.js';
import { format } from 'date-fns';
import scrollbarSize from 'dom-helpers/util/scrollbarSize';

const GridHeaderDiv = styled(Div)`
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  margin-bottom: ${({
  theme
}) => theme.spacing.md}px;
`;
const GridHeaderContentDiv = styled(Div)`
  display: flex;
  flex: 1 1;
  flex-direction: row;
`;
const GridHeaderItemDiv = styled(Div)`
  overflow: hidden;
  flex: 1 1 auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  min-height: 0;
  text-transform: capitalize;
  text-align: left;
  padding-left: 4px;
  width: 100%;
`;

class GridHeader extends Component {
  renderHeaderCells(range) {
    const weekDaysColumns = range.slice(0, this.props.weekDaysCount);
    const {
      dayFormat
    } = this.props;
    return weekDaysColumns.map((date, i) => {
      return /*#__PURE__*/createElement(GridHeaderItemDiv, {
        key: i
      }, /*#__PURE__*/createElement(H5, null, format(date, dayFormat)));
    });
  }
  render() {
    const {
      width,
      range,
      scrollRef,
      isOverflowing
    } = this.props;
    const style = {};
    if (isOverflowing) {
      style.marginRight = `${scrollbarSize()}px`;
    }
    return /*#__PURE__*/createElement(GridHeaderDiv, {
      style: style,
      elRef: scrollRef
    }, /*#__PURE__*/createElement("div", {
      style: {
        width,
        minWidth: width,
        maxWidth: width
      }
    }), /*#__PURE__*/createElement(GridHeaderContentDiv, null, this.renderHeaderCells(range)));
  }
}

export default GridHeader;
